import React = require("react");
import { Flex } from "../compositeComponents/FlexHelpers";
import { DateInputField } from "./DateInputField";
import { TimeInputField } from "./TimeInputField";
import { maybeAdjustEnd, maybeAdjustStart } from "./StartEndDateTimeFields";


type DateStartEndTimeFieldsProps = {
    start: Date,
    end: Date,
    onChanged: (start: Date, end: Date) => void,
    hideLabels?: boolean
}
export function DateStartEndTimeFields(props: DateStartEndTimeFieldsProps): JSX.Element {

    function handleStartDateChange(value: Date | null) {
        if(value === null)
            return;

        const newStart = new Date(value.getFullYear(), value.getMonth(), value.getDate(), props.start.getHours(), props.start.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustEnd(props.start, newStart, props.end);
        props.onChanged(start, end);
    }

    function handleEndDateChange(value: Date | null) {
        if(value === null)
            return;
        
        const newEnd = new Date(value.getFullYear(), value.getMonth(), value.getDate(), props.end.getHours(), props.end.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustStart(props.start, props.end, newEnd);
        props.onChanged(start, end);
    }

    function handleStartTimeChange(value: Date | null) {
        if(value === null)
            return;
        const newStart = new Date(props.start.getFullYear(), props.start.getMonth(), props.start.getDate(), value.getHours(), value.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustEnd(props.start, newStart, props.end);
        props.onChanged(start, end);
    }

    function handleEndTimeChange(value: Date | null) {
        if(value === null)
            return;

        const newEnd = new Date(props.end.getFullYear(), props.end.getMonth(), props.end.getDate(), value.getHours(), value.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustStart(props.start, props.end, newEnd);
        props.onChanged(start, end);
    }


    return (
        // Make it fill two columns
        <>
            <Flex flexDirection="row">

                <DateInputField
                    value={props.start}
                    onValueChange={handleStartDateChange}
                    hideLabel={props.hideLabels}
                    label={!isSameDate(props.start, props.end) ? "Startdato" : (!props.hideLabels ? "Dato" : "")}
                    validator={() => { return { valid: true } }} />

                {!isSameDate(props.start, props.end) &&
                    <DateInputField
                        value={props.end}
                        onValueChange={handleEndDateChange}
                        hideLabel={props.hideLabels}
                        label={"Slutdato"}
                        validator={() => { return { valid: true } }} />
                }
                
                <TimeInputField
                    value={props.start}
                    hideLabel={props.hideLabels}
                    label={"Start"}
                    onValueChange={handleStartTimeChange}
                    validator={() => { return { valid: true } }} />

                <TimeInputField
                    value={props.end}
                    hideLabel={props.hideLabels}
                    label={"Slut"}
                    onValueChange={handleEndTimeChange}
                    validator={() => { return { valid: true } }} />

            </Flex>
        </>
    );
}


export function isSameDate(start: Date, end: Date) {
    const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0);
    const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0);
    return startDate.getTime() === endDate.getTime();
}